(function () {
  "use strict";

  const GIFT_VARIANT_ID = 52050922013015; // SACCAFRANCERIEBLU
  const REQUIRED_TAG = "bon_blu";
  const BLOCKING_TAG = "blu_gift_sended";

  let isGiftSyncing = false;

  function normalizeTag(tag) {
    return String(tag || "").trim().toLowerCase();
  }

  function getCustomerTags() {
    const raw = window.__CUSTOMER_TAGS;
    if (!raw || !Array.isArray(raw)) return [];
    return raw.map(normalizeTag).filter(Boolean);
  }

  function customerEligible() {
    const tags = getCustomerTags();
    const hasRequired = tags.includes(REQUIRED_TAG);
    const hasBlocking = tags.includes(BLOCKING_TAG);

    console.log("[bonblu-gift] tags:", tags);
    console.log("[bonblu-gift] hasRequired:", hasRequired, "hasBlocking:", hasBlocking);

    return hasRequired && !hasBlocking;
  }

  async function fetchCart() {
    const res = await fetch("/cart.js", { headers: { Accept: "application/json" } });
    return res.json();
  }

  function findGiftLine(cart) {
    if (!cart || !Array.isArray(cart.items)) return null;
    return cart.items.find((i) => Number(i.variant_id) === Number(GIFT_VARIANT_ID)) || null;
  }

  // Pre-check come nel tuo script precedente
  async function isVariantAvailable(variantId) {
    try {
      const res = await fetch(`/variants/${variantId}.js`, {
        headers: { Accept: "application/json" },
        cache: "no-store",
      });

      if (!res.ok) {
        console.error("[bonblu-gift] variants.js HTTP error", variantId, res.status);
        return { ok: false, available: false, status: res.status, variant: null };
      }

      const variant = await res.json();
      const available = !!(variant && variant.available);

      console.log("[bonblu-gift] variant check:", {
        id: variantId,
        available,
        sku: variant && variant.sku,
        inventory_quantity: variant && variant.inventory_quantity,
        requires_shipping: variant && variant.requires_shipping,
      });

      return { ok: true, available, status: 200, variant };
    } catch (err) {
      console.error("[bonblu-gift] variants.js error", err);
      return { ok: false, available: false, status: 0, variant: null };
    }
  }

  // POST JSON, come nel tuo script
  async function addGiftJSON(variantId) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: { Nota: "Regalo programma fedeltà" },
      }),
    });

    const raw = await res.text();
    let data = null;
    try { data = JSON.parse(raw); } catch (_) {}

    console.log("[bonblu-gift] add.js JSON status:", res.status, "raw:", raw);
    return { ok: res.ok, status: res.status, raw, data };
  }

  // Fallback urlencoded (utile quando JSON viene bloccato o manipolato)
  async function addGiftForm(variantId) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: new URLSearchParams({ id: String(variantId), quantity: "1" }),
    });

    const raw = await res.text();
    let data = null;
    try { data = JSON.parse(raw); } catch (_) {}

    console.log("[bonblu-gift] add.js FORM status:", res.status, "raw:", raw);
    return { ok: res.ok, status: res.status, raw, data };
  }

  async function changeLineItem(lineItemKey, quantity) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: lineItemKey, quantity }),
    });
    return res.json();
  }

  async function ensureGift() {
    console.log("[bonblu-gift] ensureGift called");

    if (isGiftSyncing) return;
    isGiftSyncing = true;

    try {
      if (!customerEligible()) {
        isGiftSyncing = false;
        return;
      }

      const cart = await fetchCart();
      const giftLine = findGiftLine(cart);

      // Se già presente, non aggiungere un secondo regalo
      if (giftLine) {
        // opzionale: se qualcuno lo ha portato a qty>1, lo riportiamo a 1
        if (giftLine.quantity > 1) {
          console.log("[bonblu-gift] gift qty > 1, resetting to 1");
          await changeLineItem(giftLine.key, 1);
        }
        isGiftSyncing = false;
        return;
      }

      // Pre-check disponibilità variante come nel tuo vecchio script
      const check = await isVariantAvailable(GIFT_VARIANT_ID);
      if (!check.ok) {
        console.warn("[bonblu-gift] variant check failed, cannot add gift");
        isGiftSyncing = false;
        return;
      }

      if (!check.available) {
        console.warn("[bonblu-gift] gift variant not available, cannot add gift");
        isGiftSyncing = false;
        return;
      }

      // Provo add JSON
      const add1 = await addGiftJSON(GIFT_VARIANT_ID);
      if (!add1.ok) {
        // Fallback: form-urlencoded
        const add2 = await addGiftForm(GIFT_VARIANT_ID);
        if (!add2.ok) {
          console.error("[bonblu-gift] gift add failed with both JSON and FORM", {
            jsonStatus: add1.status,
            formStatus: add2.status,
          });
        }
      }

      // Verifica finale: esiste nel cart?
      const cartAfter = await fetchCart();
      const giftAfter = findGiftLine(cartAfter);
      console.log("[bonblu-gift] gift present after add:", !!giftAfter);

    } catch (e) {
      console.error("[bonblu-gift] ERROR:", e);
    }

    isGiftSyncing = false;
  }

  // Trigger come prima: load + intercetto add-to-cart
  document.addEventListener("DOMContentLoaded", ensureGift);

  document.addEventListener(
    "submit",
    function (evt) {
      const form = evt.target;
      if (!form || form.tagName !== "FORM") return;
      const action = (form.getAttribute("action") || "").toLowerCase();
      if (!action.includes("/cart/add")) return;
      setTimeout(ensureGift, 350);
    },
    true
  );

  // Patch fetch per add-to-cart Ajax
  const originalFetch = window.fetch;
  window.fetch = async function (input, init) {
    const result = await originalFetch.apply(this, arguments);

    try {
      const url = typeof input === "string" ? input : input && input.url ? input.url : "";
      const method = init && init.method ? String(init.method).toUpperCase() : "GET";
      const isCartAdd =
        method === "POST" && (url.includes("/cart/add") || url.includes("/cart/add.js"));

      if (isCartAdd && !isGiftSyncing) {
        setTimeout(ensureGift, 350);
      }
    } catch (_) {}

    return result;
  };

  // Esponi per test manuale
  window.ensureBonBluGift = ensureGift;
})();
